// extracted by mini-css-extract-plugin
module.exports = {"s1vjjdha":"s1vjjdha","eqls3fu":"eqls3fu","p1kiw6cl":"p1kiw6cl","jifsltj":"jifsltj","c1afyi0w":"c1afyi0w","vwncr89":"vwncr89","l1e4p20c":"l1e4p20c","b3wqxjk":"b3wqxjk"};